import { GET_OFFLINE_ENTRY_SUCCEEDED, CLEAR_OFFLINE_ENTRY_DATA } from './actionTypes';

import offlineRemote from '../../api/offlineRfsRemote';

import OfflineRfs from '../../models/OfflineRfs';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

import { receiveError } from './notificationAction';

function offlineRfsSuccess(resp: OfflineRfs) {
  return {
      type: GET_OFFLINE_ENTRY_SUCCEEDED,
      data: resp
  }
}

function offlineRfsClearData() {
  return {
    type: CLEAR_OFFLINE_ENTRY_DATA
  };
};

function receiveOfflineRfs() {

  return (dispatch: any) => {

    offlineRemote.getOfflineRsfData().then((resp: ApiResponse<OfflineRfs>) => {

      const offlineRfs: OfflineRfs | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (offlineRfs) {
        dispatch(offlineRfsSuccess(offlineRfs));
      } 
      
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

export {
  receiveOfflineRfs,
  offlineRfsClearData
}